import { jsx as e, jsxs as r } from "react/jsx-runtime";
import "react";
import '../../assets/Pill.css';const c = ({ text: l, clickHandler: n, icon: t, style: s, className: i }) => /* @__PURE__ */ e("button", { className: `pill-button ${i || ""}`, style: { ...s }, onClick: n, children: /* @__PURE__ */ r("div", { style: { alignContent: "start", justifyContent: "center", display: "flex" }, children: [
  t,
  " ",
  /* @__PURE__ */ e("b", { style: { marginLeft: t ? 10 : 0 }, children: l })
] }) });
export {
  c as default
};
